// Auto-generated translation for lv.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:33:09.167732+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Zirgu īpašniekiem",
    title: "Viss tavam zirgam. Vienā lietotnē.",
    subtitle: "Pārvaldi veselību, treniņus, plānošanu un speciālistus no vienas pārskatāmas lietas.",
    primaryCTA: {
      label: "Sākt bez maksas",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Apskatīt Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Zirga profils — svars, vakcinācija, EquiCoach, barošana un treniņi vienā ekrānā",
      caption: "Tavs zirgs — pilnīgs pārskats.",
    },
    problem: "Visticamāk, tikšanās, fotogrāfijas, treniņi, barošana un veselības dati šobrīd ir izkaisīti pa WhatsApp grupām, kastes stūriem un dažādām lietotnēm. Tāpēc trūkst pārskatāmības.",
    solution: "EquiSight pārvērš tava zirga datus vienā pilnīgā digitālā lietā, kas vienmēr ir līdzi.",
    benefits: [
      "Viens pilnīgs zirga profils katram zirgam",
      "Veselība, kalējs, zobārsts un fizioterapeits vienuviet",
      "Kalendārs ar viediem atgādinājumiem",
      "Fotogrāfijas, piezīmes un vēsture bez ierobežojumiem",
      "Visu datu dublēšana ar Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 zirgs · vienmēr bez maksas",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Vairāki zirgi + dublēšana",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gatavs sākt?",
      title: "Sāc šodien ar savu pirmo zirgu.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Vairāk zirgu. Vairāk pārskata. Vairāk pārliecības.",
    subtitle: "Pārejiet uz Premium un pārvaldiet visus savus zirgus bez ierobežojumiem — ar pilnu EquiCoach intelektu.",
    primaryCTA: {
      label: "Sāciet 14 dienas bez maksas",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Visi cenu plāni",
      href: "/#pricing",
    },
    audience: "Zirgu īpašniekiem, sporta jātniekiem un zirgu turētājiem ar vairākiem zirgiem.",
    features: [
      "Neierobežota zirgu pievienošana",
      "Pilna katra zirga vēsture",
      "Datu dublēšana",
      "Detalizēti EquiCoach ieskati",
      "Viedās atgādinājumi un plānošana",
      "Veselība un treniņi pilnībā sasaistīti",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Mazāk nekā €0,17 dienā",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gatavs?",
      title: "Pārejiet uz Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Manēžas jātniekiem",
    title: "Kļūsti labāks, arī bez sava zirga.",
    subtitle: "Seko savām nodarbībām, treniņiem un attīstībai EquiSight lietotnē — par mazāk nekā tasīte kafijas mēnesī tētim vai mammai. Vai gardas saldējuma porcijas vietā.",
    primaryCTA: {
      label: "Sākt ar Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Kā tas darbojas?",
      href: "#features",
    },
    problem: "Kā manēžas jātniekam tev bieži vien nav sava zirga, taču tu vēlies augt un pārskatīt savas nodarbības, mērķus un zirgus, uz kuriem jāj.",
    solution: "Manēžas funkcionalitāte ir iekļauta Premium plānā pēc noklusējuma — seko savai personīgajai attīstībai un aplūko piesaistītos manēžas zirgus tikai lasīšanas režīmā.",
    features: [
      "Treniņu uzskaite",
      "Mērķu izvirzīšana",
      "Progresa izsekošana",
      "Manēžas zirgu aplūkošana ar vārdu un fotoattēlu",
      "Nav piekļuves privātajiem veselības datiem",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Mēnesī · manēžas funkcionalitāte iekļauta",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Kļūsti par biedru",
      title: "Sāc kā manēžas jātniek.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Manēžām un stalliem",
    title: "Padariet savu manēžu digitāli pieejamu katram jātniekam.",
    subtitle: "Dodiet jātniekiem saikni ar zirgiem, nodarbībām un progresu — nekopīgojot sensitīvus staļļa datus.",
    primaryCTA: {
      label: "Pieprasīt piekļuvi",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Skatīt moduļus",
      href: "#features",
    },
    audience: "EquiSight palīdz manēžām un stalliem ilgāk iesaistīt jātniekus un izcelties digitālajā vidē.",
    features: [
      "Padarīt manēžas zirgus redzamus jātniekiem",
      "Katra zirga vārds un fotogrāfija",
      "Jātnieku saistīšana ar zirgiem",
      "Tikai lasīšanas piekļuve privātiem datiem",
      "Nodarbību un treniņu vēsture vienuviet",
      "Lietotāju pārvaldība ar lomām",
    ],
    benefits: [
      "Ciešāka saikne ar jātniekiem",
      "Profesionālāks tēls",
      "Papildu digitālais serviss dalībniekiem",
      "Jauns ieņēmumu avots, izmantojot lietotni",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Mēnesī · manēžas funkcionalitāte iekļauta jātniekiem",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gatavs?",
      title: "Aktivizēt Manēžas moduli.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Audzēšanas modulis",
    title: "Kontrole pār ciklu, grūsnību un kumeļa attīstību.",
    subtitle: "Pilnīgais audzēšanas modulis ķēvju īpašniekiem un audzētājiem — no pārošanas līdz kumeļam, vienā laika līnijā.",
    primaryCTA: {
      label: "Aktivizēt Audzēšanas Moduli",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Skatīt funkcijas",
      href: "#features",
    },
    audience: "Audzētājiem, ķēvju īpašniekiem un stalliem, kas pārvalda vairākas ķēves.",
    features: [
      "Cikla izsekošana",
      "Karstuma reģistrēšana",
      "Inseminācijas datu ierakstīšana",
      "Atpakaļskaitīšana līdz ehogrāfijām",
      "Grūsnības pārbaužu plānošana",
      "Ciltsraksti un izcelsme",
      "Kumeļa attīstība",
      "Visu grūsno ķēvju pārskats",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Mēnesī · Audzēšanas modulis iekļauts Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Sāciet šodien",
      title: "Sāciet audzēšanas pārvaldību.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Kalēja modulis",
    title: "Strādājiet gudrāk kā kalējs. Fiksējiet visu profesionāli.",
    subtitle: "Darba grafiks, fotoattēli, piezīmes un apstrādes vēsture vienā modulī — mazāk pārpratumu, stiprāka dokumentācija.",
    primaryCTA: {
      label: "Sākt kā kalējs",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Aplūkot Professional komplektu",
      href: "/professional",
    },
    audience: "Kalējiem, kuri vēlas uzlabot pārskatāmību, pierādījumu bāzi un komunikāciju ar klientiem.",
    features: [
      "Personīgais darba grafiks",
      "Tikšanās reizes pa klientiem",
      "Zirgu profilu apskate",
      "Pirms un pēc fotoattēlu pievienošana",
      "Apstrādes pierakstīšana",
      "Padomu un piezīmju fiksēšana",
      "ETA paziņojums klientam: \"Kalējs ir ceļā\"",
    ],
    benefits: [
      "Profesionālāks darbs",
      "Mazāk pārpratumu",
      "Labāka dokumentācijas veidošana",
      "Stiprāka pozīcija atbildības gadījumos",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Mēnesī · Kalēja modulis iekļauts Professional plānā",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gatavs?",
      title: "Aktivizēt Kalēja moduli.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Zobārsta modulis",
    title: "Pilnīga zobārstniecības dokumentācija katram zirgam.",
    subtitle: "Reģistrējiet atradnes, ārstēšanu un uzraudzību tieši EquiSight.",
    primaryCTA: {
      label: "Sākt kā zirgu zobārsts",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Skatīt Professional komplektu",
      href: "/professional",
    },
    audience: "Zirgu zobārsti, veterinārārsti un prakse, kas vēlas strādāt strukturēti.",
    features: [
      "Reģistrēt zobu pārbaudi",
      "Atradnes par katru ārstēšanu",
      "Pievienot fotoattēlus",
      "Atskaite īpašniekam",
      "Uzraudzības ieteikumi",
      "Vēsture par katru zirgu",
      "Plānot jaunu tikšanos",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Mēnesī · Zobārsta modulis iekļauts Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gatavs?",
      title: "Aktivizēt Zobārsta moduli.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Fizio / Osteo modulis",
    title: "Profesionāli sekojiet ķermenim, kustībām un atveseļošanai.",
    subtitle: "Fizioterapeitiem un osteopātiem, kuri vēlas strukturēti pavadīt zirgus.",
    primaryCTA: {
      label: "Sākt kā fizio/osteo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Apskatīt Professional paketi",
      href: "/professional",
    },
    features: [
      "Uzņemšana katram zirgam",
      "Ķermeņa atradumu reģistrēšana",
      "Foto un video pievienošana",
      "Ārstēšanas atskaites veidošana",
      "Vingrinājumu un turpmākās aprūpes kopīgošana",
      "Atveseļošanās trajektorijas sekošana",
      "Vēsture katram zirgam",
    ],
    benefits: [
      "Labāka ieskats laika gaitā",
      "Profesionāla atskaišu veidošana",
      "Skaidra saziņa ar īpašnieku, treineri un jātnieku",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Mēnesī · Fizio / Osteo modulis iekļauts Professional paketē",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gatavs?",
      title: "Aktivizēt Fizio / Osteo moduli.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Trenera modulis",
    title: "Trenē jātniekus ar datiem, mērķiem un progresu.",
    subtitle: "Padariet treniņus izmērāmus un vadību profesionālāku — vienam vai vairākiem jātniekiem.",
    primaryCTA: {
      label: "Sākt kā treneris",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Apskatīt Pro paketi",
      href: "/#pricing",
    },
    audience: "Instruktoriem, treneriem un koučiem ar vairākiem jātniekiem vai zirgiem.",
    features: [
      "Pievienot jātniekus",
      "Sekot zirgiem",
      "Iestatīt treniņu mērķus",
      "Sniegt atsauksmes",
      "Analizēt sacensību rezultātus",
      "Skatīt progresu katrai kombinācijai",
      "Izmantot protokolu analīzes treniņu fokusam",
    ],
    benefits: [
      "Labāka vadība",
      "Lielāka struktūra",
      "Profesionālāka komunikācija",
      "Ciešākas attiecības ar klientiem",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Mēnesī · Trenera modulis iekļauts Pro paketē",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gatavs?",
      title: "Aktivizēt Trenera Moduli.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Sacensību analīze",
    title: "No protokola līdz snieguma uzlabošanai.",
    subtitle: "Augšupielādē sacensību protokolu un atklāj, kur zaudē punktus — ne tikai aplūko rezultātu, bet saprot, kā kļūt labāks.",
    primaryCTA: {
      label: "Analizē savu pirmo protokolu",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Aplūko Premium",
      href: "/premium",
    },
    features: [
      "Protokola fotoattēla augšupielāde",
      "Priekšpuses un aizmugures apstrāde",
      "Klases, pārbaudes numura un tiesneša atpazīšana",
      "Punktu analīze pa posteņiem",
      "Komentāru apkopošana",
      "Stipro un vājo pušu parādīšana",
      "Tendences pēc zirga un jātnieka kombinācijas",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Mēnesī · sacensību analīze iekļauta sākot no Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gatavs?",
      title: "Sāc sacensību analīzi.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional komplekts",
    title: "Zirgu aprūpes profesionāļiem.",
    subtitle: "Kalējs, zobārsts, fizioterapeits, osteopāts vai treneris: strādājiet kopā vienā digitālā zirga kartē.",
    primaryCTA: {
      label: "Sākt kā profesionālis",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Apskatīt atsevišķos moduļus",
      href: "#features",
    },
    audience: "Professional komplekts apvieno visus specializētos moduļus vienā abonementā.",
    features: [
      "Kalēja modulis",
      "Zobārsta modulis",
      "Fizioterapeita / osteopāta modulis",
      "Kalendārs un klientu pārvaldība",
      "Zirgu profili un atskaites",
      "Ārstēšanas vēsture un dokumentācija",
      "Saziņa ar īpašnieku",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Mēnesī · visi specializētie moduļi iekļauti",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Gatavs?",
      title: "Izvēlieties Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Zirga avārijas numuri",
    title: "Vienmēr pareizā palīdzība rokas stiepiena attālumā.",
    subtitle: "Ārkārtas situācijā katra sekunde ir svarīga. Ar EquiSight visi svarīgie kontaktdati par tavu zirgu ir uzreiz pieejami — viens pieskāriens un tu zvani.",
    primaryCTA: {
      label: "Sagatavo savus avārijas kontaktus",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Sāc lietot EquiSight bez maksas",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Avārijas kontakti — zvanīt, rakstīt WhatsApp vai navigēt uz veterinārārstu, klīniku un kalēju ar vienu pieskārienu",
      caption: "Viens pieskāriens. Bez panikas meklēšanas.",
      embeddedFrame: true,
    },
    problem: "Tavam zirgam kaut kas notiek — kolika, trauma, panika. Un tad sākas meklēšana. Ko tu zvani? Vai tev ir pareizais numurs? Vai tas ir steidzamais numurs? Dārgais laiks tiek zaudēts.",
    solution: "Ar EquiSight viss ir uzreiz pie rokas. Bez meklēšanas. Bez šaubām. Viens pieskāriens un tu esi sasniedzis kontaktu.",
    scenario: {
      title: "Iztēlojies — tavs zirgs uzrāda kolikas pazīmes.",
      steps: [
        "Tu atver EquiSight",
        "Noklikšķini uz \"Veterinārārsts\"",
        "Zvani uzreiz",
      ],
      tagline: "Bez stresa. Bez meklēšanas. Tikai rīcība.",
    },
    features: [
      "Visi avārijas numuri vienā vietā",
      "Zvanīšana no lietotnes ar vienu pieskārienu",
      "WhatsApp ziņa ar vienu pieskārienu",
      "Tieša navigācija uz adresi",
      "Katram zirgam sava kontaktu saraksts",
      "Veterinārārsts, klīnika, kalējs, zobārstniecība, fizioterapija",
      "Adrese un maršruta apraksts pieejams uzreiz",
      "Atzīmē iecienītākos numurus ar zvaigznīti",
      "Steidzamie numuri (112, 144) vienmēr augšā",
    ],
    benefits: [
      "Miers un kontrole ārkārtas situācijā",
      "Visiem stallī ir vieni un tie paši numuri pie rokas",
      "Vairs nav aizmirstu vizītkaršu",
      "Reaģē sekundes ātrāk steidzamos gadījumos",
    ],
    audience: "Zirgu īpašniekiem, kopējiem, treneriem un stalliem — ikvienam, kas ir atbildīgs par zirgu.",
    showcase: {
      eyebrow: "Iepriekš sagatavots tevis vietā",
      title: "13 kontaktu kategorijas — gatavas aizpildīšanai.",
      description: "No veterinārārsta un steidzamās klīnikas līdz seglotājam, instruktoram un ganību pārvaldniekam. EquiSight pārzina tavu pasauli un sagatavo pareizos kontaktu laukus tevis vietā. Pieskar, aizpildi, gatavs.",
      bullets: [
        "Neatliekamā palīdzība un veselība — veterinārārsts, steidzamā palīdzība, klīnika, saindēšanās līnija",
        "Ikdienas kopšana — kalējs, zobārstniecība, fizioterapija, instruktors",
        "Stalls un ganības — stalmeistars, ganību pārvaldnieks, pensionātu stalls",
        "Barība un materiāli — siena, spēkbarības, salmu piegādātāji",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Avārijas kontaktu pārvaldības ekrāns — visi ieteiktie kontakti pa kategorijām",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Zirga avārijas numuru kontrolsaraksts",
      items: [
        "Veterinārārsts",
        "Steidzamā klīnika (24/7)",
        "Dzīvnieku ātrā palīdzība · 144",
        "Kalējs",
        "Rezerves kontaktpersona",
        "Vispārējais trauksmes numurs · 112",
      ],
      cta: {
        label: "Atvērt EquiSight un aizpildīt uzreiz",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Avārijas numuri",
          price: "Gratis",
          note: "Vienmēr bez maksas · ikvienam, katrā abonementā",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Parūpējies, lai būtu gatavs",
      title: "Pirms tas ir nepieciešams.",
      href: "/#waitlist",
    },
    microcopy: [
      "Bez saistībām",
      "Iestatīts 2 minūtēs",
      "Vienmēr maināms",
    ],
  },
};

export default LANDINGS;
